import { toastConfig } from 'config'
import { affiliationGroups, roles as roleKeys } from 'keys'
import { allRoles } from 'keys/roles'
import { toast } from 'react-toastify'

class User {

    // user - מציין את פרטי המשתמש
    // userRoles - מציין את פרטי התפקידים של המשתמש
    // affiliationID - מציין אם המשתמש בבעלות מוסד מסויים, וכל התפקידים הם רק במסגרת אותו מוסד

    constructor(user, userRoles, affiliationID) {
        const { id, tz, en_last_name, en_first_name, username, phone, gender, email, password, first_name, last_name } = user

        if (id)
            this.id = id

        this.en_first_name = en_first_name
        this.en_last_name = en_last_name

        this.username = username
        this.password = password
        this.initial_pass = password
        this.first_name = first_name
        this.last_name = last_name

        this.email = email
        this.tz = tz
        this.phone_number = phone
        this.gender = gender?.id

        if (affiliationID) {
            this.affiliation = affiliationID
            this.context_aff_id = affiliationID
        }

        let nUserRoles = []
        let contacts = []

        userRoles?.forEach(userRole => {
            const { affiliationGroup, affiliation, roles, is_contact, is_principal } = userRole
            const isSchoolGroup = affiliationGroup?.name == affiliationGroups.schools

            if (is_contact || is_principal) {
                contacts.push({ affiliation: affiliation, is_principal: is_principal, is_contact: is_contact })
            }

            roles.forEach(({ role, school_year, data }) => {
                if (role?.name) {
                    const roleType = allRoles[role.name]
                    if (role.name)
                        if (roleType == roleKeys.all) {
                            nUserRoles.push({
                                role: role.id,
                                school_year: school_year?.id || school_year
                            })
                        }
                        else if (roleType == roleKeys.principal) {
                            nUserRoles.push({
                                role: role.id,
                                affiliation: affiliation.id,
                                school_year: school_year?.id || school_year
                            })
                        }
                        else {
                            if (roleType == roleKeys.coordinator) {
                                if (!isSchoolGroup) {
                                    toast(
                                        'ישנם מספר תפקידים שהגדרת ללקוחות חוץ בית ספריות שאנו לא תומכים בהם, לקוחות חוץ בית ספריות מורשות ליצור תפקידים בעל סמכות מורה או מנהל בלבד, תפקידים אלו לא נוצרו עבור המשתמש',
                                        toastConfig)
                                    return
                                }

                                else {
                                    const { grades } = data[0]
                                    if (grades)
                                        grades.forEach(grade => {
                                            nUserRoles.push({
                                                role: role.id,
                                                school_year: school_year?.id || school_year,
                                                grade: grade.id,
                                                affiliation: affiliation.id
                                            })
                                        })
                                }
                            }
                            if (roleType == roleKeys.teacher) {
                                data.forEach(item => {
                                    const { classes, learning_groups } = item

                                    const learningUnits = classes || learning_groups

                                    learningUnits.forEach(learning_unit => {
                                        nUserRoles.push({
                                            role: role.id,
                                            school_year: school_year?.id || school_year,
                                            learning_unit: learning_unit.id
                                        })
                                    });
                                });
                            }
                            if (roleType == roleKeys.single) {

                                if (!isSchoolGroup) {
                                    toast(
                                        'ישנם מספר תפקידים שהגדרת ללקוחות חוץ בית ספריות שאנו לא תומכים בהם, לקוחות חוץ בית ספריות מורשות ליצור תפקידים בעל סמכות מורה או מנהל בלבד, תפקידים אלו לא נוצרו עבור המשתמש',
                                        toastConfig)
                                    return
                                }

                                else data?.forEach(item => {
                                    const { test_takers } = item || {}

                                    if (item.test_takers)
                                        test_takers.forEach(test_taker => {
                                            nUserRoles.push({
                                                role: role.id,
                                                school_year: school_year?.id || school_year,
                                                test_taker: test_taker.test_taker_id
                                            })
                                        });
                                    // if select role and dont select test_takers
                                    else {
                                        nUserRoles.push({
                                            role: role.id,
                                            school_year: school_year?.id || school_year,
                                        })
                                    }
                                });
                            }
                        }
                }
            });

            this.user_roles = nUserRoles
        })

        // this.contacts = contacts
    }
}

export default User